export default "__VITE_ASSET__1OXRjlPe__ 400w, __VITE_ASSET__BDxeAH$N__ 700w, __VITE_ASSET__RQJUyDMM__ 900w";